import { Image, View } from 'react-native';
import React, { useCallback, useState } from 'react';
import { MyTextInput, Spacing, Typography, Button } from 'components/src';
import {
  createUseStyles,
  logOut,
  Platform,
  storeToken,
  usePatchUserUpdateUserPassword,
} from 'core/src';
import FontAwesome6 from 'react-native-vector-icons/FontAwesome6';
import Feather from 'react-native-vector-icons/Feather';
import Fontisto from 'react-native-vector-icons/Fontisto';
import { useTranslation } from 'react-i18next';

const FontistoX = Fontisto as unknown as React.ComponentType<any>;
const FontAwesome6X = FontAwesome6 as unknown as React.ComponentType<any>;
const FeatherX = Feather as unknown as React.ComponentType<any>;

const UpdatePassword = () => {
  const { styles, colors } = useStyles();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const { i18n } = useTranslation();
  const [error, setError] = useState<any>([]);

  const logOutDispatch = storeToken.useDispatch();

  const { mutate } = usePatchUserUpdateUserPassword({
    onSuccess: (data) => {
      logOutDispatch(logOut());
    },
    onError: (data) => {
      //@ts-ignore
      setError(data.message);
    },
  });

  const updatePassword = useCallback(() => {
    mutate({
      requestBody: {
        password: oldPassword,
        newPassword,
      },
    });
  }, [oldPassword, newPassword]);

  const disabled =
    oldPassword === '' || newPassword === '' || repeatPassword !== newPassword
      ? true
      : false;

  return (
    <View>
      <View style={styles.logo}>
        <Image
          source={require('../../../../../../assets/src/images/logo.png')}
          style={styles.image}
          resizeMode="contain"
        />
      </View>
      <View style={[styles.mainView]}>
        <Spacing vertical={10} />
        <View style={styles.loginContainer}>
          <Typography
            text={i18n.t('updatePassword')}
            size={30}
            weight="bold"
            color={colors.secondryColor}
          />
          <Spacing vertical={10} />
          {typeof error?.message === 'string' ? (
            <Typography
              text={error?.message}
              color="red"
              weight="bold"
              classes={{
                backgroundColor: 'rgba(239, 239, 240, 0.8)',
                padding: 10,
              }}
            />
          ) : (
            error?.message?.map((err: any) => (
              <Typography
                text={err}
                color="red"
                weight="bold"
                classes={{
                  backgroundColor: 'rgba(239, 239, 240, 0.8)',
                  padding: 10,
                }}
              />
            ))
          )}
        </View>
        <Spacing vertical={10} />
        <MyTextInput
          classes={styles.input}
          inlineImageLeft={
            <FeatherX
              name="key"
              size={25}
              color={colors.secondryColorOpacity}
            />
          }
          placeholderTextColor={colors.secondryColorOpacity}
          placeholder={i18n.t('oldPassword')}
          change={(text: string) => {
            setOldPassword(text);
          }}
        />
        <Spacing vertical={10} />
        <View
          style={{ backgroundColor: 'rgba(239, 239, 240, 0.8)', padding: 10 }}
        >
          <Typography
            text={'دارای حداقل 8 کاراکتر شامل اعداد و حروف انگلیسی'}
          />
        </View>
        <Spacing vertical={4} />

        <MyTextInput
          classes={styles.input}
          inlineImageLeft={
            <FontistoX
              name="key"
              size={25}
              color={colors.secondryColorOpacity}
            />
          }
          placeholderTextColor={colors.secondryColorOpacity}
          placeholder={i18n.t('newPassword')}
          change={(text: string) => {
            setNewPassword(text);
          }}
        />

        <Spacing vertical={10} />
        <MyTextInput
          classes={styles.input}
          inlineImageLeft={
            <FontAwesome6X
              name="repeat"
              size={25}
              color={colors.secondryColorOpacity}
            />
          }
          placeholderTextColor={colors.secondryColorOpacity}
          placeholder={i18n.t('repeatNewPassword')}
          change={(text: string) => {
            setRepeatPassword(text);
          }}
        />
        <Spacing vertical={20} />
        <View style={styles.buttonView}>
          <Button
            disabled={disabled}
            onClick={updatePassword}
            classes={disabled ? styles.disabledButton : styles.button}
          >
            <Typography text={i18n.t('update')} color={colors.container} />
          </Button>
        </View>
      </View>
    </View>
  );
};

const useStyles = createUseStyles(({ colors, theme }) => ({
  mainView: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    paddingHorizontal: 30,
    marginVertical: 10,
    ...Platform.select({
      desktop: {
        alignItems: 'center',
      },
    }),
  },
  logo: {
    marginVertical: 10,
    paddingHorizontal: 30,
  },
  image: {
    width: '100%',
    height: 60,
  },
  title: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  button: {
    backgroundColor: colors.secondryColor,
    width: 100,
    padding: 8,
    textAlign: 'center',
    alignItems: 'center',
    borderRadius: 5,
    elevation: 3,
  },
  disabledButton: {
    backgroundColor: 'gray',
    width: 100,
    padding: 8,
    textAlign: 'center',
    alignItems: 'center',
    borderRadius: 5,
    elevation: 3,
    opacity: 0.4,
  },
  buttonView: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  loginContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  input: {
    backgroundColor: colors.container,
  },
}));

export { UpdatePassword };
